import './Popover-b609f443.css';

var classes = {"Popover":"prc-Popover-Popover-v1ShS","PopoverContent":"prc-Popover-PopoverContent-nMzFS"};

export { classes as default };
